module.exports = __webpack_public_path__ + "img/4.f20142b8.png";